<template>
  <v-card
    class="taktplan"
    :style="`width: calc(100% - ${getSideBarWidth()})`"
    color="color-1"
    ref="taktplan"
    id="taktplan"
    @mousemove="moveTaktareaStartMouseMove($event),
      moveTrainStartMouseMove($event),
      flexBarHeightMouseMove($event),
      moveTaktPlanMouseMove($event)"
    @mouseup="moveTaktareaStartMouseUp(),
      moveTrainStartMouseUp(),
      flexBarHeightMouseUp()"
    @mouseleave="moveTaktareaStartMouseUp(),
      moveTrainStartMouseUp(),
      flexBarHeightMouseUp()"
    @mousedown="moveTaktPlanMouseDown($event)"
    @touchmove="flexBarHeightMouseMove($event)"
    @touchend="flexBarHeightMouseUp()"
    @touchcancel="flexBarHeightMouseUp()"
    >
    <!-- AUTOPILOT TEST -->
    <StandardDialog v-if="getAutopilots.length" @click-outside="clearAutopilots()" style="z-index: 30">
      <template #content>
        <div class="pa-5">
          <h2>AUTO.pilot messages</h2>
          <span v-for="(ap, index) in getAutopilots" :key="'apindex'+index">
            <div v-for="(ap_msg, msg_index) in ap.messages" :key="'msg_index'+msg_index">
              <b v-if="ap.blocking">{{ap_msg}}</b>
              <i v-else>{{ap_msg}}</i>
            </div>
          </span>
          <v-btn @click="clearAutopilots()" class="mt-5" color="green">Dismiss</v-btn>
        </div>
      </template>
    </StandardDialog>
    <!-- AUTOPILOT TEST -->
    <!-- SnackBar -->
    <transition
      name="snack-bar-slide-y"
      >
      <SnackBar
        v-if="snackbar.show"
        :snackbar="snackbar"
        >
        <!-- @clickSnackBar="snackBarBulk()" -->
        <template #activator>
          <Activator
            class="self-centered cursor-s-resize"
            :key="`snackbar_activator`"
            @mousedown.native="updateSnackbar({show: false, hover: false})"
            />
        </template>
          <template #header>
            <template v-if="snackbar.action === 'create'">
              <div v-if="!snackbar.reference"> Create in all</div>
              <div v-else-if="snackbar.reference.before">Create Waggon before all</div>
              <div v-else>Create Waggon after all</div>
              <TWorkPackage
                v-if="snackbar.target_type.substring(snackbar.target_type.length-5) === 'steps'"
                class="ma-2"
                :workpackage_count="1"
                :zoom="0.7"
                :workpackage="snackbar.parent_cache"
                />
              <TWaggon
                v-else-if="['twaggons', 'tworkpackages'].includes(snackbar.target_type)"
                class="ma-2"
                :workpackage_count="snackbar.target_type === 'tworkpackages'?snackbar.parent_cache.tworkpackages.length:getUObject({type: 'twaggons', id: snackbar.reference.id}).tworkpackages.length"
                :waggon="snackbar.target_type === 'tworkpackages'?snackbar.parent_cache:getUObject({type: 'twaggons', id: snackbar.reference.id})"
                >
                <template #content="{waggon}">
                  <TWorkPackage
                    v-for="workpackage in getUObjects({type: 'tworkpackages', ids: waggon.tworkpackages})"
                    :key="`movewaggonworkpackage${workpackage.id}`"
                    :workpackage_count="waggon.tworkpackages.length"
                    :workpackage="workpackage"
                    />
                </template>
              </TWaggon>
              <div>in train:</div>
            </template>
            <template v-else-if="snackbar.action === 'update' || snackbar.target_type.substring(snackbar.target_type.length-5) === 'steps'">
              <div>Apply this change in all</div>
              <TWorkPackage
                v-if="['kages', 'steps'].includes(snackbar.target_type.substring(snackbar.target_type.length-5))"
                class="ml-2 mr-2"
                :workpackage_count="1"
                :zoom="0.7"
                :workpackage="getUObject({
                  type: 'tworkpackages',
                  id: snackbar.target_type === 'tworkpackages'?snackbar.target_id:snackbar.parent_id
                })"
                />
              <div>in train:</div>
            </template>
            <template v-else-if="snackbar.action === 'updateparent'">
              <div>Move</div>
              <TWorkPackage
                class="ml-2 mr-2"
                :workpackage_count="1"
                :zoom="0.7"
                :workpackage="getUObject({
                  type: 'tworkpackages',
                  id: snackbar.target_id
                })"
                />
              <div>in all Taktareas in train:</div>
            </template>
            <template v-else-if="snackbar.action === 'updatetaktareastart'">
              <div>Apply this change in all following Taktareas in Train</div>
            </template>
            <template v-else-if="snackbar.action === 'delete'">
              <div>Apply this change in whole train: </div>
            </template>
          </template>
          <template #body>
            <template v-if="snackbar.action === 'create'">
              <div class="mt-1 mb-1">
              <StandardStep
                v-if="snackbar.target_type.substring(snackbar.target_type.length-5) === 'steps'"
                width="340px"
                :step="snackbar.u_object"
                :readonly="true"
                :step_type="snackbar.target_type.substring(1)"
                :color="getUObject({
                  type: 'tworkpackages',
                  id: snackbar.parent_id
                }).color"
                />
                <TWorkPackage
                  v-if="snackbar.target_type === 'tworkpackages'"
                  class="ma-2"
                  :workpackage_count="1"
                  :zoom="0.7"
                  :workpackage="snackbar.u_object"
                  />
              </div>
            </template>
            <template v-else-if="snackbar.action === 'update'">
              <template v-if="snackbar.target_type === 'tworkpackages'">
                <div style="width: 70%" class="mt-1 mb-1">
                  <div>value: {{snackbar.value_name}}</div>
                  <div>from: {{snackbar.value_old}}</div>
                  <div>to: {{snackbar.value_new}}</div>
                </div>
              </template>
              <template v-else>
                <div class="mt-1 mb-1">
                  <div>update step from</div>
                  <StandardStep
                    width="340px"
                    :step="snackbar.update_old_values"
                    :readonly="true"
                    :step_type="snackbar.target_type.substring(1)"
                    :color="getUObject({
                      type: 'tworkpackages',
                      id: snackbar.parent_id
                    }).color"
                    />
                  <div>to</div>
                  <StandardStep
                    width="340px"
                    :step="snackbar.update"
                    :readonly="true"
                    :step_type="snackbar.target_type.substring(1)"
                    :color="getUObject({
                      type: 'tworkpackages',
                      id: snackbar.parent_id
                    }).color"
                    />
                </div>
              </template>
            </template>
            <template v-else-if="snackbar.action === 'updateposition'">
              <template v-if="snackbar.target_type.substring(snackbar.target_type.length-5) === 'steps'">
                <div class="mt-1 mb-1">
                  <div>Move step {{Math.abs(snackbar.position_difference)}} Position{{Math.abs(snackbar.position_difference) > 1?'s':''}} {{ 0 > snackbar.position_difference?'up':'down'}}</div>
                  <StandardStep
                    width="340px"
                    :step="getUObject({
                      type: snackbar.target_type,
                      id: snackbar.target_id
                    })"
                    :readonly="true"
                    :step_type="snackbar.target_type.substring(1)"
                    :color="getUObject({
                      type: 'tworkpackages',
                      id: snackbar.parent_id
                    }).color"
                    />
                </div>
              </template>
              <TFlex
                align_items="center"
                v-else
                >
                <div>Move</div>
                <TWorkPackage
                  v-if="snackbar.target_type === 'tworkpackages'"
                  class="ma-2"
                  :workpackage_count="1"
                  :zoom="0.7"
                  :workpackage="getUObject({
                    type: 'tworkpackages',
                    id: snackbar.target_id
                  })"
                  />
                <TWaggon
                  v-else-if="snackbar.target_type === 'twaggons'"
                  class="ma-2"
                  :workpackage_count="getUObject({type: 'twaggons', id: snackbar.target_id}).tworkpackages.length"
                  :waggon="getUObject({type: 'twaggons', id: snackbar.target_id})"
                  >
                  <template #content="{waggon}">
                    <TWorkPackage
                      v-for="workpackage in getUObjects({type: 'tworkpackages', ids: waggon.tworkpackages})"
                      :key="`movewaggonworkpackage${workpackage.id}`"
                      :workpackage_count="waggon.tworkpackages.length"
                      :workpackage="workpackage"
                      />
                    </template>
                  </TWaggon>
                <div>
                  {{Math.abs(snackbar.position_difference)}} Position{{Math.abs(snackbar.position_difference) > 1?'s':''}} {{ 0 > snackbar.position_difference?'forwards':'backwards'}}
                </div>
              </TFlex>
            </template>
            <template v-else-if="snackbar.action === 'updateparent'">
              <TFlex
                align_items="center"
                >
                <div>From</div>
                <TWaggon
                  class="ma-2"
                  :workpackage_count="snackbar.parent_cache.tworkpackages.length"
                  :waggon="snackbar.parent_cache"
                  >
                  <template #content="{waggon}">
                    <TWorkPackage
                      v-for="workpackage in getUObjects({type: 'tworkpackages', ids: waggon.tworkpackages})"
                      :key="`movewaggonworkpackage${workpackage.id}`"
                      :workpackage_count="waggon.tworkpackages.length"
                      :workpackage="workpackage"
                      />
                    </template>
                  </TWaggon>
                  <div>to</div>
                  <TWaggon
                    class="ma-2"
                    :workpackage_count="snackbar.new_parent_cache.tworkpackages.length"
                    :waggon="snackbar.new_parent_cache"
                    >
                    <template #content="{waggon}">
                      <TWorkPackage
                        v-for="workpackage in getUObjects({type: 'tworkpackages', ids: waggon.tworkpackages})"
                        :key="`movewaggonworkpackage${workpackage.id}`"
                        :workpackage_count="waggon.tworkpackages.length"
                        :workpackage="workpackage"
                        />
                      </template>
                    </TWaggon>
              </TFlex>
            </template>
            <template v-else-if="snackbar.action === 'updatetaktareastart'">
              <div class="mt-2 mb-2">Move Taktarea {{Math.abs(snackbar.start_difference)}} Position{{Math.abs(snackbar.start_difference) > 1?'s':''}} {{ 0 > snackbar.start_difference?'foreward':'backwards'}}</div>
            </template>
            <template v-else-if="snackbar.action === 'delete'">
              <template v-if="snackbar.target_type.substring(snackbar.target_type.length-5) === 'steps'">
                <div class="mt-1 mb-1">
                  <div>Delete step:</div>
                  <StandardStep
                    width="340px"
                    :step="snackbar.target_cache"
                    :readonly="true"
                    :step_type="snackbar.target_type.substring(1)"
                    :color="getUObject({
                      type: 'tworkpackages',
                      id: snackbar.parent_id
                      }).color"
                    />
                </div>
              </template>
              <TFlex v-else width="100%" class="mt-1 mb-1" align_items="center">
                <div>Delete: </div>
                <TWorkPackage
                  v-if="snackbar.target_type === 'tworkpackages'"
                  class="ml-2 mr-2"
                  :workpackage_count="1"
                  :zoom="1.0"
                  :workpackage="snackbar.target_cache"
                  />
                <TWaggon
                  v-else-if="snackbar.target_type === 'twaggons'"
                  class="ma-2"
                  :workpackage_count="snackbar.target_cache.tworkpackages.length"
                  :waggon="snackbar.target_cache"
                  >
                  <template #content="{waggon}">
                    <TWorkPackage
                      v-for="workpackage in getUObjects({type: 'tworkpackages', ids: waggon.tworkpackages})"
                      :key="`deletewaggonworkpackage${workpackage.id}`"
                      :workpackage_count="waggon.tworkpackages.length"
                      :workpackage="workpackage"
                      />
                  </template>
                </TWaggon>
              </TFlex>
            </template>
          </template>
          <template #footer>
            <TFlex justify_content="space-around" align_items="center" class="mt-1 mb-1">
              <template v-if="snackbar.action === 'update' && snackbar.target_type === 'tworkpackages'">
                <StandardSwitch
                  class="ma-0"
                  :value="snackbar.check_old_value"
                  :label="`only if ${snackbar.value_name} is ${snackbar.value_old}`"
                  @changeValue="updateSnackbar({check_old_value: !snackbar.check_old_value})"
                />
              </template>
              <v-btn
                color="green lighten-1"
                @click="applySnackbar()"
                >
                apply ({{snackbar.action === 'create'?snackbar.affected_parents.length:getAffectedTargets.length}})
              </v-btn>
            </TFlex>
          </template>
      </SnackBar>
    </transition>
    <!-- InfoBox-->
    <transition
      name="zoom-translate"
      >
      <router-view v-if="!isEditMode" name="info_box"></router-view>
    </transition>

    <!-- SideBar -->
    <transition
      name="slide"
      >
      <router-view v-if="isEditMode || ($route.matched[2] && $route.matched[2].name === 'MilestonesSideBar')" name="side_bar"></router-view>
    </transition>

    <!-- Taktplan -->
    <v-container
      fluid
      class="pa-0"
      style="position: absolute"
      >
      <!-- FlexBar -->
      <FlexBar
        :project_length="isSpatialView?getProjectLength(project_id):getProjectLength(project_id)+1"
        header_width="var(--project_taktplan_ta_header_width) * 1px + var(--project_taktplan_spatial_header_width) * 1px"
        :set_statistics_height="getStatisticsHeightVariables.set_statistics_height"
        >
        <template #statistics-activator>
          <Activator
            class="self-centered cursor-row-resize"
            :key="`statistics_activator`"
            @mousedown.native="flexBarHeightMouseDown({
              evt: $event,
              })"
            @touchstart.native="flexBarHeightMouseDown({
              evt: $event,
              })"
            />
        </template>
        <!-- Statistics -->
        <template #statistics>
          <!-- Takt time Highlighter statistics-->
          <TaktTimeHighLighter
            v-if="getCurrentTaktIndex(project_id) !== false"
            :index="isSpatialView ? Math.abs(getCurrentTaktIndex(project_id)) : Math.abs(getCurrentTaktIndex(project_id)) + 1"
            header_width="var(--project_taktplan_ta_header_width) * 1px + var(--project_taktplan_spatial_header_width) * 1px"
            />
          <TaktTimeHighLighter
            v-if="getCurrentTaktIndex(project_id) !== false &&
                  getCurrentTaktIndex(project_id) >= 0"
            :index="isSpatialView ? getCurrentTaktIndex(project_id) + 1 : getCurrentTaktIndex(project_id) + 2"
            header_width="var(--project_taktplan_ta_header_width) * 1px + var(--project_taktplan_spatial_header_width) * 1px"
            />
          <HeaderRowStatistics
            ref="header_row_statistics"
            :set_statistics_height="getStatisticsHeightVariables.set_statistics_height"
            :isSpatialView="isSpatialView"
            >
            <template #basic-info>
              <v-img
                max-height="80%"
                class="ma-2"
                contain
                gradient="to top,rgba(0, 0, 0, 0),rgba(0, 0, 0, 0.05),rgba(0, 0, 0, 0.4)"
                :src="project.image"
              >
                <v-btn icon @click="$refs.project_image.click()" v-if="isEditMode">
                  <input
                    v-show="false"
                    ref="project_image"
                    type="file"
                    @change="addProjectImage()"
                    capture="camera"
                  />
                  <v-icon>add_a_photo</v-icon>
                </v-btn>
              </v-img>
              <!-- <StandardFlexBox
                height="100%"
                >
                <div>
                  <v-icon class="ml-2 mr-1">access_time</v-icon>
                  {{ project.duration }}
                </div>
                <div>
                  <v-icon class="ml-3 mr-1">train</v-icon>
                  {{ project.information.trains_count }}
                </div>
                <div>
                  <v-icon class="ml-3 mr-1">crop_free</v-icon>
                  {{ project.information.taktareas_count }}
                </div>
                <div>
                  <v-icon class="ml-2 mr-1">crop_landscape</v-icon>
                  {{ project.information.waggons_count }}
                </div>
                <div>
                  <v-icon class="ml-3 mr-1">dns</v-icon>
                  {{ project.information.work_packages_count }}
                </div>
              </StandardFlexBox> -->
              <!-- <v-btn
                :to="{name: 'ProjectSettings'}"
                >
                Project Settings
              </v-btn> -->
            </template>
            <template #statistic-settings>
              <StandardOverflowButton
                :click_to_open="true"
                :value="{value: getStatisticSettings.value}"
                :options="{value: [
                    {value: 'workpackages', icon: 'dns', tooltip: 'Number of WORK.packages'},
                    {value: 'time_effort_planned', icon: 'speed', tooltip: 'Planned time effort'},
                    {value: 'manpower_planned', icon: 'accessibility', tooltip: 'Planned manpower'},
                    {value: 'duration_planned', icon: 'timer', tooltip: 'Duration planned'},
                    {value: 'time_effort_actual', icon: 'speed', tooltip: 'Actual time effort'},
                    {value: 'manpower_actual', icon: 'accessibility', tooltip: 'Actual manpower'},
                    {value: 'duration_actual', icon: 'timer', tooltip: 'Actual duration'},
                    {value: 'twork_step_count', icon: 'list', tooltip: 'Number of WORK.steps'},
                    {value: 'tdesign_step_count', icon: 'design_services', tooltip: 'Number of DESIGN.steps'},
                    {value: 'tlogistic_step_count', icon: 'airport_shuttle', tooltip: 'Number of LOGISTIC.steps'},
                    {value: 'tquality_step_count', icon: 'high_quality', tooltip: 'Number of QUALITY.steps'},
                    {value: 'tdefect_step_count', icon: 'broken_image', tooltip: 'Number of DEFECT.steps'},
                    {value: 'thandover_step_count', icon: 'sync_alt', tooltip: 'Number of HANDOVER.steps'},
                    {value: 'image_count', icon: 'photo', tooltip: 'Number of images'},
                    {value: 'log_entry_count', icon: 'book', tooltip: 'Number of LOG.entries'},
                    {value: 'costs_budget_labour', icon: 'account_balance_wallet', tooltip: 'Labour budget'},
                    {value: 'costs_budget_material', icon: 'account_balance_wallet', tooltip: 'Material budget'},
                    {value: 'costs_paid_out_labour', icon: 'payments', tooltip: 'Labour paid out'},
                    {value: 'costs_paid_out_material', icon: 'payments', tooltip: 'Material paid out'},
                    {value: 'costs_paid_tendered_labour', icon: 'shopping_cart', tooltip: 'Labour tendered'},
                    {value: 'costs_paid_tendered_material', icon: 'shopping_cart', tooltip: 'Material tendered'},
                    {value: 'calendar', icon: 'calendar_today', tooltip: 'Calendar'},
                  ]}"
                @button-clicked="setShowMilestones(false)"
                @select-option="setStatisticSettings({setting: $event.setting, value: $event.value}),
                                setShowMilestones(false)"
                />
              <v-divider class="mt-1 mb-1" width="90%" color="grey"/>
              <StandardOverflowButton
                :click_to_open="true"
                :value="{cumulative: getStatisticSettings.cumulative}"
                :options="[
                  'manpower_planned',
                  'manpower_actual',
                  'time_effort_planned',
                  'time_effort_actual',
                  'calendar',
                  ].includes(getStatisticSettings.value)?
                  {cumulative: [
                    {value: false, icon: 'bar_chart', tooltip: 'Cumulative'},
                  ]}
                  :
                  {cumulative: [
                    {value: false, icon: 'bar_chart', tooltip: 'Per TAKT.time'},
                    {value: true, icon: 'signal_cellular_alt', tooltip: 'Cumulative'}
                  ]}
                "
                @button-clicked="setShowMilestones(false)"
                @select-option="setStatisticSettings({setting: $event.setting, value: $event.value}),
                                setShowMilestones(false)"
                />
              <v-divider class="mt-1 mb-1" width="90%" color="grey"/>
              <StandardOverflowButton
                :click_to_open="true"
                icon="filter_alt"
                :multiselect="true"
                :button_color="getStatisticSettings.filter? 'color-3':''"
                :value="{
                  icons: getStatisticSettings.icons,
                  colors: getStatisticSettings.colors,
                  status: getStatisticSettings.status,
                  trains: getStatisticSettings.trains
                  }"
                :options="{
                  icons: getTWorkpackageIcons,
                  colors: getTWorkpackageColors,
                  status: getFullStatusArray,
                  trains: getStatisticsTrainSelector(project_id),
                  }
                  "
                @button-clicked="setShowMilestones(false)"
                @select-option="setStatisticSettings({setting: $event.setting, value: $event.value}),
                                setShowMilestones(false)"
                />
                <v-btn
                  icon
                  :class="!getStatisticSettings.filter? 'color-3':''"
                  @click="setStatisticSettings({setting: 'filter'}),setShowMilestones(false)"
                  >
                  <v-icon>visibility_off</v-icon>
                </v-btn>
                <v-divider class="mt-1 mb-1" width="90%" color="grey"/>
                <v-btn icon
                  @click="setShowMilestones(!isShowMilestones)"
                  :class="isShowMilestones?'grey darken-3':''"
                  >
                  <div class="milestone-icon"/>
                </v-btn>
            </template>
          </HeaderRowStatistics>
          <StatisticsBackgroundBlurr
            ref="statistics_background_blurr"
            :project_length="getProjectLength(project_id)"
            :set_statistics_height="getStatisticsHeightVariables.set_statistics_height"
            :statistics="getStatistics(project_id)"
            :current_takt_index="getCurrentTaktIndex(project_id)"
            :current_day_index="getCurrentDayIndex(project_id)"
            >
            <template #default="statistics_slot">
              <template v-if="isShowMilestones">
                <StandardFlexBox
                  class="pt-2"
                  direction="column"
                  width="100%"
                  height="100%"
                  :no_wrap="true"
                  >
                <MileStonesLane
                  class="cursor-pointer"
                  name="Project"
                  @click.native="$router.push({name: 'ProjectMilestones'})"
                  >
                  <MileStone
                    v-for="pmilestone in getPMileStones(project_id)"
                    :key="pmilestone.pmilestone.id"
                    :token="pmilestone.pmilestone.token"
                    status="done"
                    type="project"
                    :takt_index="pmilestone.takt_index"
                    :offset_y="pmilestone.offset_y"
                    :distance_min="pmilestone.distance_min"
                    @click.native.prevent.stop="$router.push({name: 'ProjectMilestonesDetails', params: {pmilestone_id: pmilestone.pmilestone.id}})"
                    />
                  <MileStone
                    v-if="getNewPMilestone(project_id).date !== ''"
                    type="new-project"
                    :takt_index="getNewPMilestone(project_id).takt_index"
                    :token="getNewPMilestone(project_id).pmilestone.token"
                    :large="true"
                    />
                </MileStonesLane>
                <MileStonesLane
                  class="cursor-pointer"
                  v-for="train in getUObjects({type: 'trains', ids: project.trains})"
                  :key="train.id"
                  :name="train.name"
                  @click.native="$router.push({name: 'TrainMilestones'})"
                  >
                  <template v-for="milestone in getMileStones(project_id)">
                  <MileStone
                    v-if="milestone.trains.includes(train.id)"
                    :key="milestone.milestone.id"
                    :token="milestone.milestone.token"
                    status="done"
                    type="train"
                    :takt_index="milestone.takt_index"
                    :offset_y="milestone.offset_y"
                    :distance_min="milestone.distance_min"
                    @click.native.prevent.stop="$router.push({name: 'TrainMilestonesDetails', params: {milestone_id: milestone.milestone.id}})"
                    />
                  </template>
                  <MileStone
                  v-if="getNewMilestone(project_id).trains.includes(train.id)"
                  type="new-train"
                  :takt_index="getNewMilestone(project_id).takt_index"
                  :token="getNewMilestone(project_id).milestone.token"
                  :large="true"
                  />
                </MileStonesLane>
                </StandardFlexBox>
              </template>
              <template v-else>
                <StatisticsTakt
                  v-for="(takt_values, takt_values_index) in statistics_slot.statistics.takt_values"
                  :key="`statistics_takt_${takt_values_index}`"
                  >
                  <template
                    v-if="getStatisticSettings.value === 'calendar'"
                    >
                    <StatisticsCard
                      v-for="(takt_value, takt_value_index) in takt_values.values"
                      :key="`statistics_takt_value_${takt_value_index}`"
                      :value="takt_value.value"
                      :background_color="takt_values_index === statistics_slot.current_takt_index && takt_value_index === statistics_slot.current_day_index?'var(--v-primary-base)':''"
                      />
                  </template>
                  <template v-else>
                  <StatisticsBeamTaktSum
                    v-if="takt_values.takt_sum !== 0"
                    >
                    {{takt_values.takt_sum}}
                  </StatisticsBeamTaktSum>
                  <StatisticsBeam
                    v-for="(takt_value, takt_value_index) in takt_values.values"
                    :key="`statistics_takt_value_${takt_value_index}`"
                    :value="takt_value.value"
                    :max_value="statistics_slot.statistics.max_takt_sum"
                    :color="takt_value.color"
                    />
                  </template>
                </StatisticsTakt>
              </template>
            </template>
          </StatisticsBackgroundBlurr>
        </template>
        <!-- Header Columns Months -->
        <template #header-columns-months>
          <!-- :width="`calc(${project_taktplan_spatial_header_width1}px * var(--taktplan_zoom))`" -->
          <HeaderPlaceholder
            width="calc(var(--project_taktplan_spatial_header_width) * 1px * var(--taktplan_zoom))"
            height="26px"
            z_index="5"
            sticky_left="0px"
            >
            <template #right-middle>
              <ActivatorSlider
                class="self-centered cursor-col-resize"
                css_variable="--project_taktplan_spatial_header_width"
              />
              <!-- @changeValue="setWidth($event)" -->
              <!-- :value="getWidth" -->
            </template>
          </HeaderPlaceholder>
          <HeaderPlaceholder
            width="calc(var(--project_taktplan_ta_header_width) * 1px * var(--taktplan_zoom))"
            height="26px"
            z_index="4"
            sticky_left="calc(var(--project_taktplan_spatial_header_width) * 1px * var(--taktplan_zoom))"
            >
            <template #right-middle>
              <ActivatorSlider
                class="self-centered cursor-col-resize"
                css_variable="--project_taktplan_ta_header_width"
              />
              <!-- @changeValue="setWidth($event)" -->
              <!-- :value="getWidth" -->
            </template>
          </HeaderPlaceholder>
          <HeaderPlaceholder
            :key="isSpatialView"
            v-if="!isSpatialView"
            width="calc((var(--workpackage_width) + 8px) * var(--taktplan_zoom))"
            height="26px"
            z_index="3"
          />
          <!-- <HeaderColumnMonth
            z_index="4"
            sticky_left="0"
            :duration="4"
            >
            <v-btn
              @click="isSpatialView = !isSpatialView"
              >
              spatial view
            </v-btn>
          </HeaderColumnMonth> -->


          <!-- <HeaderColumnMonth
            z_index="3"
            />
          <HeaderColumnMonth
            z_index="3"
            />
          <HeaderColumnMonth
            z_index="3"
            /> -->
          <HeaderColumnMonth
            z_index="3"
            v-for="month in getCalendar(project_id).months"
            :key="month.name"
            :duration="month.duration"
            >
            <!-- {{month.name}} -->
            <TText :value="`${$store.state.Ultra.months[month.integer]} {year}`" :value_props="{year: ` '${month.year.toString().substring(2,4)}`}"/>
          </HeaderColumnMonth>
          <HeaderColumnMonth
            v-if="getCalendar(project_id).months.length === 0"
            z_index="3"
            :duration="getProjectLength(project_id)"
          />
          <HeaderColumnMonth
            z_index="3"
            />
        </template>
        <!-- Header Columns -->
        <template #header-columns>
          <!-- :width="`calc(${project_taktplan_spatial_header_width}px * var(--taktplan_zoom))`" -->
          <HeaderPlaceholder
            width="calc(var(--project_taktplan_spatial_header_width) * 1px * var(--taktplan_zoom))"
            height="calc((var(--workpackage_width) + 8px) * var(--taktplan_zoom))"
            max_height="75px"
            z_index="4"
            sticky_left="0px"
            >
            <StandardSwitch
              :value="isSpatialView"
              @changeValue="
              isEditMode? leaveEditMode({project_id: project_id}):'',
              $route.name !== 'ProjectTaktPlan'?$router.push({name: 'ProjectTaktPlan'}):'',
              setSpatialView(!isSpatialView)
              "
              icon="home"
            />
          </HeaderPlaceholder>
          <!-- v-if="isSpatialView" -->
          <HeaderPlaceholder
            width="calc(var(--project_taktplan_ta_header_width) * 1px * var(--taktplan_zoom))"
            height="calc((var(--workpackage_width) + 8px) * var(--taktplan_zoom))"
            max_height="75px"
            z_index="4"
            sticky_left="calc(var(--project_taktplan_spatial_header_width) * 1px * var(--taktplan_zoom))"
            style="overflow: hidden"
            >
            <v-btn
              small
              @click="toggleAllTrains()"
              >
              <v-icon>keyboard_arrow_down</v-icon> all
            </v-btn>
          </HeaderPlaceholder>
          <HeaderColumn
            v-if="!isSpatialView"
            z_index="3"
            >
            <v-btn
            v-if="isEditMode"
            @click="$router.push({
              name: 'EditCalendar'
            })"
            :class="is_show_side_bar? 'grey darken-2':''"
            icon
            >
              <v-icon>
                calendar_today
              </v-icon>
            </v-btn>
          </HeaderColumn>
          <!-- <template v-else>
            <HeaderColumn
              z_index="4"
              sticky_left="0"
              >
              <v-btn
              v-if="isEditMode"
              icon
              @click="$router.push({
                name: 'EditCalendar'
              })"
              :class="is_show_side_bar? 'grey darken-2':''"
              >
                <v-icon>
                  calendar_today
                </v-icon>
              </v-btn>
              <div v-else>
                TAKT. <br>
                area
              </div>
            </HeaderColumn>
            <HeaderColumn
              :z_index="isSpatialView?4:3"
              :sticky_left="isSpatialView?'calc(1 *  (var(--workpackage_width) + 8px) * var(--taktplan_zoom))':false"
              >
              Info
            </HeaderColumn>
            <HeaderColumn
              :z_index="isSpatialView?4:3"
              :sticky_left="isSpatialView?'calc(2 * (var(--workpackage_width) + 8px) * var(--taktplan_zoom))':false"
              >
              Size
            </HeaderColumn>
            <HeaderColumn
              :z_index="isSpatialView?4:3"
              :sticky_left="isSpatialView?'calc(3 * (var(--workpackage_width) + 8px) * var(--taktplan_zoom))':false"
              >
            </HeaderColumn>
          </template> -->
          <template
            v-if="getCalendar(project_id).takt_times.length !== 0"
            >
            <HeaderColumn
              v-for="(takt_time, index) in getCalendar(project_id).takt_times"
              :key="`takttime${index}`"
              z_index="3"
              >
              <DateCircle
                @click.native="setShowCalendarWeeks(), setShowMilestones(false)"
                :value="isShowCalendarWeeks?takt_time.calendar_weeks:[takt_time.first_day_string, takt_time.last_day_string]"
              />
            </HeaderColumn>
          </template>
          <template v-else>
            <HeaderColumn
              v-for="(takt_time, index) in getProjectLength(project_id)"
              :key="`takttime${index}`"
              z_index="3"
              />
          </template>
          <HeaderColumn
            z_index="3"
            >
          </HeaderColumn>
        </template>
      </FlexBar>

      <v-btn
        v-if="project.trains.length === 0 && $route.name !== 'AddTrain'"
        @click="$router.push({
          name: 'AddTrain',
          params: {
            project_id: project_id,
            train_index: 0,
            direction: 0,
          }
          })">
        Add Train
      </v-btn>
      <template v-else-if="!isSpatialView">
      <!-- Train -->
      <draggable
        :key="`trains${project_id}`"
        animation="300"
        forceFallback="true"
        fallbackOnBody="true"
        :disabled="draggable_disabled || !isEditMode || $route.name !=='ProjectTaktPlan'? true:false"
        :value="project.trains"
        @end="updateUObjectPosition({
            url: [
              {projects: project_id},
              {trains: project.trains[$event.oldIndex]},
            ],
            update: {
              position: $event.newIndex - $event.oldIndex
            }
          })"
        >
        <!-- @end="trainChangePosition({
          project_id: project_id,
          drag_evt: $event
        })" -->
          <!-- v-once -->
          <Train

            v-for="(train, train_index) in getUObjects({type: 'trains', ids: project.trains})"
            :key="`train${train.id}`"
            >
            <template #train>
              <draggable
                :key="`taktareas${train.id}`"
                animation="300"
                forceFallback="true"
                fallbackOnBody="true"
                :disabled="draggable_disabled || train.closed || !isEditMode || $route.name !=='ProjectTaktPlan'? true:false"
                :value="train.taktareas"
                @end="updateUObjectPosition({
                    url: [
                      {projects: project_id},
                      {trains: train.id},
                      {taktareas: train.taktareas[$event.oldIndex]},
                    ],
                    update: {
                      position: $event.newIndex - $event.oldIndex
                    }
                  })"
                >
                <!-- @end="taktareaChangePosition({
                  project_id: project_id,
                  train_id: train.id,
                  drag_evt: $event
                })" -->
              <v-hover
                v-for="(taktarea, taktarea_index) in getUObjects({type: 'taktareas', ids: train.taktareas})"
                :key="`taktareahover${taktarea.id}`"
                :disabled="!isEditMode"
                >
                <template #default="hover_taktarea_slot">
                  <transition
                    name="grow-y"
                    >
                    <TaktArea
                      v-if="train.closed && taktarea_index === 0 || !train.closed"
                      :ref="`taktarea${taktarea.id}`"
                      :key="`taktarea${taktarea.id}`"
                      :project_length="getProjectLength(project_id)"
                      header_width="var(--project_taktplan_ta_header_width) * 1px + var(--project_taktplan_spatial_header_width) * 1px"
                      v-intersect="onintersect"
                      >
                      <template #taktarea>
                        <!-- Takt time Highlighter -->
                        <TaktTimeHighLighter
                          v-if="getCurrentTaktIndex(project_id) !== false"
                          :index="isSpatialView ? Math.abs(getCurrentTaktIndex(project_id)) : Math.abs(getCurrentTaktIndex(project_id)) + 1"
                          header_width="var(--project_taktplan_ta_header_width) * 1px + var(--project_taktplan_spatial_header_width) * 1px"
                          z_index="2"
                          />
                        <TaktTimeHighLighter
                          v-if="getCurrentTaktIndex(project_id) !== false &&
                                getCurrentTaktIndex(project_id) >= 0"
                          :index="isSpatialView ? getCurrentTaktIndex(project_id) + 1 : getCurrentTaktIndex(project_id) + 2"
                          header_width="var(--project_taktplan_ta_header_width) * 1px + var(--project_taktplan_spatial_header_width) * 1px"
                          z_index="2"
                          />
                        <!-- :readonly="hover_taktarea_slot.hover && isEditMode? false:true" -->

                        <!-- :color="isInsertingTrain &&
                        $route.params.train_index + $route.params.direction === train_index?'blue':false" -->
                        <template v-if="!train.closed">
                          <HeaderTrainOpen
                            v-if="taktarea_index === 0"
                            :taktarea_count="train.closed?1:train.taktareas.length"
                            @click.native="
                              toggleWaggonTransition(),
                              updateUDObject({
                                url: [
                                  {projects: project_id},
                                  {trains: train.id},
                                ],
                                update: {
                                  closed: !train.closed
                                }
                              })"
                            >
                            <div>{{train.name}}</div>
                          </HeaderTrainOpen>
                          <div v-else style="width: calc(var(--project_taktplan_spatial_header_width) * 1px * var(--taktplan_zoom))"/>
                        </template>
                        <HeaderRow
                          v-if="train.closed"
                          :class="['TrainMilestonesAdd', 'TrainMilestonesEdit'].includes($route.name)?'border-white-hover cursor-pointer':!isEditMode?'cursor-pointer':''"
                          z_index="3"
                          width="calc(var(--project_taktplan_spatial_header_width) * 1px * var(--taktplan_zoom))"
                          sticky_left="0px"
                          :key="`trainname${train.id}`"
                          :border_color="getHeaderRowBorder('trains', train, new_milestone, 'black')"
                          :border_width="!['TrainMilestonesAdd', 'TrainMilestonesDetails', 'TrainMilestonesEdit'].includes($route.name)?'0px 0px 1px 0px':''"
                          :color="train.closed?'grey darken-1':''"
                          :text="train.closed? train.name:taktarea.name"
                          :readonly="isEditMode && $route.name === 'ProjectTaktPlan'? false:true"
                          @click.native="
                            isEditMode?
                            handleHeaderRowClick(train, taktarea)
                            :
                            updateUDObject({
                              url: [
                                {projects: project_id},
                                {trains: train.id}
                              ],
                              update: {
                                closed: false
                              }
                            })"
                          @changeValue="updateUObject({
                              url: [
                                {projects: project_id},
                                {trains: train.id},
                              ],
                              update: {
                                name: $event
                              }
                            })"
                          >
                          <template #middle-left>
                            <ActivatorDelete
                              class="self-centered cursor-not-allowed"
                              :key="`taktareadeleteactivator${taktarea.id}`"
                              v-if="hover_taktarea_slot.hover && isEditMode && $route.name === 'ProjectTaktPlan'"
                              color="#EF5350"
                              @activatorDelete="
                                deleteUObject({
                                    url: [
                                      {projects: project_id},
                                      {trains: train.id}
                                    ]
                                  })"
                              />
                            </template>
                          <template #top-center>
                              <Activator
                                class="self-centered cursor-cell"
                                v-if="hover_taktarea_slot.hover && isEditMode && $route.name === 'ProjectTaktPlan'"
                                :addTrain="true"
                                @click.native="$router.push({
                                  name: 'AddTrain',
                                  params: {
                                    project_id: project_id,
                                    train_index: train_index,
                                    train_id: train.id,
                                    direction: 0,
                                  }
                                  })"
                                />
                          </template>
                          <template #bottom-center>
                              <Activator
                                class="self-centered cursor-cell"
                                v-if="train.closed && hover_taktarea_slot.hover && isEditMode && $route.name === 'ProjectTaktPlan'"
                                :addTrain="true"
                                @click.native="$router.push({
                                  name: 'AddTrain',
                                  params: {
                                    project_id: project_id,
                                    train_index: train_index,
                                    train_id: train.id,
                                    direction: 1,
                                  }
                                  })"
                                />
                          </template>
                        </HeaderRow>
                        <!-- taktarea header -->
                        <HeaderRow
                          v-if="!train.closed"
                          :class="['TrainMilestonesAdd', 'TrainMilestonesEdit'].includes($route.name)?'border-white-hover cursor-pointer':''"
                          z_index="3"
                          sticky_left="calc(var(--project_taktplan_spatial_header_width) * 1px * var(--taktplan_zoom))"
                          width="calc(var(--project_taktplan_ta_header_width) * 1px * var(--taktplan_zoom))"
                          :key="`taktareaname${taktarea.id}`"
                          :border_color="getHeaderRowBorder('taktareas', taktarea, new_milestone, '#424242')"
                          :border_width="!['TrainMilestonesAdd', 'TrainMilestonesDetails', 'TrainMilestonesEdit'].includes($route.name)?'0px 0px 1px 0px':''"
                          inner_border="solid 1px rgba(255,255,255,0.8)"
                          :text="taktarea.name"
                          :readonly="isEditMode && $route.name === 'ProjectTaktPlan'? false:true"
                          @click.native="handleHeaderRowClick(train, taktarea)"
                          @changeValue="updateUObject({
                              url: [
                                {projects: project_id},
                                {trains: train.id},
                                {taktareas: taktarea.id}
                              ],
                              update: {
                                name: $event
                              }
                            })"
                          >
                          <template #middle-left>
                            <ActivatorDelete
                              class="self-centered cursor-not-allowed"
                              :key="`taktareadeleteactivator${taktarea.id}`"
                              v-if="hover_taktarea_slot.hover && isEditMode && $route.name === 'ProjectTaktPlan'"
                              color="#EF5350"
                              @activatorDelete="
                                deleteUObject({
                                    url: train.taktareas.length === 1?
                                    [
                                      {projects: project_id},
                                      {trains: train.id}
                                    ]
                                    :
                                    [
                                      {projects: project_id},
                                      {trains: train.id},
                                      {taktareas: taktarea.id}
                                    ]
                                  }).then(() => {
                                  train.taktareas.length === 1?
                                  '':changeTaktAreaStartBulk()
                                  })"
                              />
                            </template>
                          <template #top-center>
                            <ActivatorInsert
                              class="self-centered cursor-cell"
                              :key="`taktarea_add_top_activator${taktarea.id}`"
                              v-if="hover_taktarea_slot.hover && isEditMode && $route.name === 'ProjectTaktPlan'"
                              @insert="parseInt($event) > 0?createUObject({
                                  url: [
                                    {projects: project_id},
                                    {trains: train.id},
                                    {taktareas: 'copytaktareabulk'},
                                    {showWithEntitiesNormalized: ''}
                                  ],
                                  u_object: {
                                    taktarea_copy: taktarea.id,
                                    taktareas: getTaktareasForCreateBulk(
                                      $event,
                                      taktarea.taktarea_start,
                                      taktarea_index + 1,
                                      0
                                    )
                                  }
                                })
                              :''
                              "
                              />
                          </template>
                          <template #bottom-center>
                            <ActivatorInsert
                              class="self-centered cursor-cell"
                              :key="`taktarea_add_bottom_activator${taktarea.id}`"
                              v-if="hover_taktarea_slot.hover && isEditMode && $route.name === 'ProjectTaktPlan'"
                              @insert="parseInt($event) > 0?createUObject({
                                  url: [
                                    {projects: project_id},
                                    {trains: train.id},
                                    {taktareas: 'copytaktareabulk'},
                                    {showWithEntitiesNormalized: ''}
                                  ],
                                  u_object: {
                                    taktarea_copy: taktarea.id,
                                    taktareas: getTaktareasForCreateBulk(
                                      $event,
                                      taktarea.taktarea_start,
                                      taktarea_index + 1,
                                      0
                                    )
                                  }
                                })
                              :''
                              "
                              />
                          </template>
                        </HeaderRow>
                        <HeaderPlaceholder
                          v-else
                          class="cursor-pointer"
                          width="calc(var(--project_taktplan_ta_header_width) * 1px * var(--taktplan_zoom))"
                          height="calc((var(--workpackage_height) + 8px) * var(--taktplan_zoom))"
                          z_index="4"
                          sticky_left="calc(var(--project_taktplan_spatial_header_width) * 1px * var(--taktplan_zoom))"
                          border_color="black"
                          border_width="0px 1px 1px 0px"
                          style="overflow: hidden;"
                          @click.native="updateUDObject({
                              url: [
                                {projects: project_id},
                                {trains: train.id}
                              ],
                              update: {
                                closed: false
                              }
                            })"
                          >
                          <TrainHead :zoom="0.3" color="rgba(255,255,255,0.9)"/>
                          <div style="margin: 0px 2px 0px 2px">{{train.taktareas.length}}</div>
                          <TrainTail :zoom="0.3" color="rgba(255,255,255,0.9)"/>
                        </HeaderPlaceholder>

                        <!-- <HeaderRow
                          :class="['TrainMilestonesAdd', 'TrainMilestonesEdit'].includes($route.name)?'border-white-hover cursor-pointer':''"
                          z_index="3"
                          width="calc(var(--project_taktplan_ta_header_width) * 1px * var(--taktplan_zoom))"
                          :key="`taktareaname${taktarea.id}`"
                          :border_color="
                          getHeaderRowBorder(
                            train.closed?'trains':'taktareas',
                            train.closed?train:taktarea,
                            new_milestone,
                            )"
                          :color="train.closed?'grey darken-1':''"
                          :text="train.closed? train.name:taktarea.name"
                          :readonly="isEditMode && $route.name === 'ProjectTaktPlan'? false:true"
                          @click.native="handleHeaderRowClick(train, taktarea)"
                          @changeValue="updateUObject({
                              url: train.closed?
                              [
                                {projects: project_id},
                                {trains: train.id},
                              ]
                              :
                              [
                                {projects: project_id},
                                {trains: train.id},
                                {taktareas: taktarea.id}
                              ]
                              ,
                              update: {
                                name: $event
                              }
                            })"
                          >
                          <template #middle-left>
                            <ActivatorDelete
                              class="self-centered cursor-not-allowed"
                              :key="`taktareadeleteactivator${taktarea.id}`"
                              v-if="hover_taktarea_slot.hover && isEditMode && $route.name === 'ProjectTaktPlan'"
                              color="#EF5350"
                              @activatorDelete="
                                deleteUObject({
                                    url: train.closed || train.taktareas.length === 1?
                                    [
                                      {projects: project_id},
                                      {trains: train.id}
                                    ]
                                    :
                                    [
                                      {projects: project_id},
                                      {trains: train.id},
                                      {taktareas: taktarea.id}
                                    ]
                                  }).then(() => {
                                  train.closed || train.taktareas.length === 1?
                                  '':changeTaktAreaStartBulk()
                                  })"
                              />
                            </template>
                          <template #top-center>
                            <ActivatorInsert
                              class="self-centered cursor-cell"
                              :key="`taktarea_add_top_activator${taktarea.id}`"
                              v-if="!train.closed && hover_taktarea_slot.hover && isEditMode && $route.name === 'ProjectTaktPlan'"
                              @insert="parseInt($event) > 0?createUObject({
                                  url: [
                                    {projects: project_id},
                                    {trains: train.id},
                                    {taktareas: 'copytaktareabulk'},
                                    {showWithEntitiesNormalized: ''}
                                  ],
                                  u_object: {
                                    taktarea_copy: taktarea.id,
                                    taktareas: getTaktareasForCreateBulk(
                                      $event,
                                      taktarea.taktarea_start,
                                      taktarea_index + 1,
                                      0
                                    )
                                  }
                                })
                              :''
                              "
                              />
                              <Activator
                                class="self-centered cursor-cell"
                                v-if="train.closed && hover_taktarea_slot.hover && isEditMode && $route.name === 'ProjectTaktPlan'"
                                :addTrain="true"
                                @click.native="$router.push({
                                  name: 'AddTrain',
                                  params: {
                                    project_id: project_id,
                                    train_index: train_index,
                                    train_id: train.id,
                                    direction: 0,
                                  }
                                  })"
                                />
                          </template>
                          <template #bottom-center>
                            <ActivatorInsert
                              class="self-centered cursor-cell"
                              :key="`taktarea_add_bottom_activator${taktarea.id}`"
                              v-if="!train.closed && hover_taktarea_slot.hover && isEditMode && $route.name === 'ProjectTaktPlan'"
                              @insert="parseInt($event) > 0?createUObject({
                                  url: [
                                    {projects: project_id},
                                    {trains: train.id},
                                    {taktareas: 'copytaktareabulk'},
                                    {showWithEntitiesNormalized: ''}
                                  ],
                                  u_object: {
                                    taktarea_copy: taktarea.id,
                                    taktareas: getTaktareasForCreateBulk(
                                      $event,
                                      taktarea.taktarea_start,
                                      taktarea_index + 1,
                                      0
                                    )
                                  }
                                })
                              :''
                              "
                              />
                              <Activator
                                class="self-centered cursor-cell"
                                v-if="train.closed && hover_taktarea_slot.hover && isEditMode && $route.name === 'ProjectTaktPlan'"
                                :addTrain="true"
                                @click.native="$router.push({
                                  name: 'AddTrain',
                                  params: {
                                    project_id: project_id,
                                    train_index: train_index,
                                    train_id: train.id,
                                    direction: 1,
                                  }
                                  })"
                                />
                          </template>
                        </HeaderRow> -->


                        <!-- <HeaderRow
                          :z_index="hover_taktarea_slot.hover? 1:0"
                          :key="`taktareadescription${taktarea.id}`"
                          :text="train.closed? train.description:taktarea.description"
                          :text_color="'var(--v-color-0-base)'"
                          :readonly="isEditMode && $route.name === 'ProjectTaktPlan'? false:true"
                          @changeValue="
                            updateUObject({
                                url: train.closed?
                                [
                                  {projects: project_id},
                                  {trains: train.id},
                                ]
                                :
                                [
                                  {projects: project_id},
                                  {trains: train.id},
                                  {taktareas: taktarea.id}
                                ]
                                ,
                                update: {
                                  description: $event
                                }
                              })"
                        />
                        <HeaderRow
                          z_index="0"
                          :key="`taktareasize${taktarea.id}`"
                          :text="getSquareMeter(train, taktarea)"
                          :text_color="'var(--v-color-0-base)'"
                          :readonly="isEditMode && $route.name === 'ProjectTaktPlan' && !train.closed?false:true"
                          :unit="parseInt(taktarea.square_meter) !== 0
                            && taktarea.square_meter !== ''? 'm²':false"
                          @changeValue="updateUObject({
                              url: [
                                {projects: project_id},
                                {trains: train.id},
                                {taktareas: taktarea.id}
                              ]
                              ,
                              update: {
                                square_meter: parseInt($event)
                              }
                            })"
                        /> -->
                        <Placeholder
                          :ref="`placeholder_trainstart_${train.id}`"
                          :key="`placeholder_trainstart_${train.id}`"
                          :count="train.train_start"
                          :class="getMoveTrainStartVariables.move_train_start? '':'transition-all'"
                          >
                          <template #bottom-right>
                            <Activator
                              class="self-centered cursor-col-resize"
                              :key="`taktareaactivator${taktarea.id}`"
                              v-if="train.closed && taktarea_index === 0 && hover_taktarea_slot.hover && isEditMode && $route.name === 'ProjectTaktPlan'"
                              @mouseenter.native="draggable_disabled = true"
                              @mouseleave.native="getMoveTrainStartVariables.move_train_start? '':draggable_disabled = false"
                              @mousedown.native="moveTrainStartMouseDown({
                                train_id: train.id,
                                taktarea_id: taktarea.id,
                                taktarea_index: taktarea_index,
                                train_start: train.train_start,
                                evt: $event,
                                })"
                            />
                          </template>
                        </Placeholder>
                        <TrainHead
                          v-if="taktarea_index === 0"
                          :is_taktarea="!train.closed"
                          class="cursor-pointer"
                          :key="`trainhead${taktarea.id}`"
                          @click.native="
                            toggleWaggonTransition(),
                            updateUDObject({
                              url: [
                                {projects: project_id},
                                {trains: train.id},
                              ],
                              update: {
                                closed: !train.closed
                              }
                            })"
                        />
                        <Placeholder
                          v-else :count="1"
                          :key="`placeholdertrainhead${taktarea.id}`"
                        />
                        <Placeholder
                          :ref="`placeholder_taktareastart_${taktarea.id}`"
                          :key="`placeholder_taktareastart_${taktarea.id}`"
                          :count="taktarea.taktarea_start"
                          :class="getMoveTaktareaStartVariables.move_taktarea_start? '':'transition-all'"
                          >
                          <template #bottom-right>
                            <Activator
                              class="self-centered cursor-col-resize"
                              :key="`taktareaactivator${taktarea.id}`"
                              v-if="!train.closed && (hover_taktarea_slot.hover || (snackbar.show && snackbar.hover && snackbar.action === 'updatetaktareastart' && snackbar.affected_targets.includes(taktarea.id))) && isEditMode && $route.name === 'ProjectTaktPlan'"
                              @mouseenter.native="draggable_disabled = true"
                              @mouseleave.native="getMoveTaktareaStartVariables.move_taktarea_start?'':draggable_disabled = false"
                              @mousedown.native="moveTaktareaStartMouseDown({
                                train_id: train.id,
                                taktarea_id: taktarea.id,
                                taktarea_start: taktarea.taktarea_start,
                                evt: $event,
                                })"
                            />
                          </template>
                        </Placeholder>
                        <draggable
                          class="display-flex"
                          :key="`taktarewaggons${taktarea.id}`"
                          animation="300"
                          forceFallback="true"
                          fallbackOnBody="true"
                          :disabled="!hover_taktarea_slot.hover ||
                                     !isEditMode ||
                                     $route.name !=='ProjectTaktPlan'?
                                     true:false"
                          :value="taktarea.twaggons"
                          @update="requestSnackbarUpdatePosition({
                              url: [
                                {projects: project_id},
                                {trains: train.id},
                                {taktareas: taktarea.id},
                                {twaggons: taktarea.twaggons[$event.oldIndex]},
                              ],
                              update: {
                                position: $event.newIndex - $event.oldIndex
                              }
                            }).then((payload) => {
                              updateUObjectPosition(payload)
                          })"
                          >
                          <v-hover
                            v-for="(waggon, waggon_index) in getUObjects({type: 'twaggons', ids: taktarea.twaggons})"
                            :key="`waggonhoveractivtor${waggon.id}`"
                            :disabled="getMoveTaktareaStartVariables.move_taktarea_start"
                            >
                            <template #default="hover_waggon_slot">
                            <transition
                              :name="waggon_transition?'grow-x':''"
                              >
                              <!-- :easter_egg="!isEditMode && waggon.tworkpackages[0] % 10 === 0 && hover_waggon_slot.hover" -->
                              <TWaggon
                                :class="$route.name !== 'ProjectTaktPlan' &&
                                               waggon.tworkpackages.length === 0?
                                               'cursor-pointer':''"
                                :key="`waggon${waggon.id}`"
                                :workpackage_count="waggon.tworkpackages.length"
                                :easter_egg="false"
                                @click.native="$route.name !== 'ProjectTaktPlan' &&
                                               waggon.tworkpackages.length === 0?
                                               openWaggonInfo(waggon, train.id, taktarea.id, waggon.id, $event):''"

                                >
                                <template #prepend
                                  v-if="hover_waggon_slot.hover &&
                                        $route.name === 'ProjectTaktPlan'
                                        && isEditMode"
                                  >
                                  <Activator
                                    :key="`waggonactivatorprepend${waggon.id}`"
                                    class="self-centered cursor-cell"
                                    @click.native="requestSnackbarCreate({
                                      url: [
                                        {projects: project_id},
                                        {trains: train.id},
                                        {taktareas: taktarea.id},
                                        {twaggons: ''},
                                        {showWithEntitiesNormalized: ''}
                                      ],
                                      u_object: {
                                        position: waggon_index + parseInt(1)
                                      },
                                      reference: {
                                        before: true,
                                        type: 'twaggons',
                                        id: waggon.id
                                      }
                                    }).then((payload) => {
                                      createUObject(payload)
                                    })"
                                  />
                                  <!-- @click.native="tWaggonInsert({
                                    project_id: project_id,
                                    train_id: train.id,
                                    taktarea_id: taktarea.id,
                                    twaggon_index: waggon_index,
                                    twaggon_id: waggon.id,
                                    before: true,
                                    snack_bar: { bulk: false }
                                  })" -->
                                </template>
                                <template #append
                                  v-if="hover_waggon_slot.hover &&
                                        $route.name === 'ProjectTaktPlan'
                                        && isEditMode"
                                  >
                                  <Activator
                                    :key="`waggonactivatorappend${waggon.id}`"
                                    class="self-centered cursor-cell"
                                    @click.native="requestSnackbarCreate({
                                      url: [
                                        {projects: project_id},
                                        {trains: train.id},
                                        {taktareas: taktarea.id},
                                        {twaggons: ''},
                                        {showWithEntitiesNormalized: ''}
                                      ],
                                      u_object: {
                                        position: waggon_index + parseInt(2)
                                      },
                                      reference: {
                                        before: false,
                                        type: 'twaggons',
                                        id: waggon.id
                                      }
                                    }).then((payload) => {
                                      createUObject(payload)
                                    })"
                                  />
                                  <!-- @click.native="tWaggonInsert({
                                    project_id: project_id,
                                    train_id: train.id,
                                    taktarea_id: taktarea.id,
                                    twaggon_index: waggon_index + 1,
                                    twaggon_id: waggon.id,
                                    before: false,
                                    snack_bar: { bulk: false }
                                  })" -->
                                </template>
                                <template #badge>
                                  <StandardDeleteButton
                                    v-if="hover_waggon_slot.hover && isEditMode && $route.name === 'ProjectTaktPlan'"
                                    :key="`waggonbadge${waggon.id}`"
                                    direction="left"
                                    @clickDelete="requestSnackbarDelete({
                                        url: [
                                          {projects: project_id},
                                          {trains: train.id},
                                          {taktareas: taktarea.id},
                                          {twaggons: waggon.id}
                                        ],
                                      }).then((payload) => {
                                        deleteUObject(payload)
                                      })"
                                  />
                                  <!-- @clickDelete="tWaggonDelete({
                                    project_id: project_id,
                                    train_id: train.id,
                                    taktarea_id: taktarea.id,
                                    twaggon_id: waggon.id,
                                    twaggon_index: waggon_index,
                                    snack_bar: { bulk: false }
                                  })" -->
                                </template>
                                <template #content="{easter_egg}">
                                  <StandardHover
                                    v-if="(hover_waggon_slot.hover && $route.name === 'ProjectTaktPlan') ||
                                          (snackbar && snackbar.show && snackbar.hover && snackbar.target_type === 'twaggons' && (getAffectedTargets.includes(waggon.id) || snackbar.affected_references.includes(waggon.id))) ||
                                          (snackbar && snackbar.show && snackbar.hover && snackbar.target_type === 'tworkpackages' && snackbar.action === 'create' && snackbar.affected_parents.includes(waggon.id)) ||
                                          (snackbar && snackbar.show && snackbar.hover && snackbar.action === 'updateparent' && (snackbar.affected_parents.includes(waggon.id) || snackbar.affected_new_parents.includes(waggon.id)))

                                    "
                                    :key="`waggonhover${waggon.id}`"
                                    :easter_egg="easter_egg"
                                    :class="easter_egg?'cursor-none':(isEditMode? 'cursor-grab':waggon.tworkpackages.length !== 0?'cursor-pointer':'cursor-default')"
                                    @click.native="openWaggonInfo(waggon, train.id, taktarea.id, waggon.id, $event)"
                                  />
                                  <draggable
                                    class="display-flex flex-wrap"
                                    :key="`workpackageswaggon${waggon.id}`"
                                    :id="`workpackageswaggon${waggon.id}`"
                                    :group="`workpackages_taktarea_${taktarea.id}`"
                                    :component-data="getDraggableStyle()"
                                    animation="300"
                                    forceFallback="true"
                                    fallbackOnBody="true"
                                    :disabled="!isEditMode ||
                                               $route.name !== 'TaktPlanWorkPackageEdit'?
                                               true:false"
                                    :value="waggon.tworkpackages"
                                    @update="requestSnackbarUpdatePosition({
                                        url: [
                                          {projects: project_id},
                                          {trains: train.id},
                                          {taktareas: taktarea.id},
                                          {twaggons: waggon.id},
                                          {tworkpackages: waggon.tworkpackages[$event.oldIndex]}
                                        ],
                                        update: {
                                          position: $event.newIndex - $event.oldIndex
                                        }
                                      }).then((payload) => {
                                        updateUObjectPosition(payload)
                                    })"
                                    @start="draggable_old_twaggon_id = waggon.id"
                                    @remove="requestSnackbarUpdateParent({
                                      url: [
                                        {projects: project_id},
                                        {trains: train.id},
                                        {taktareas: taktarea.id},
                                        {twaggons: waggon.id},
                                        {tworkpackages: waggon.tworkpackages[$event.oldIndex]},
                                        {updateparent: ''}
                                      ],
                                      update: {
                                        parent_id: parseInt($event.to.id.substring(18, $event.to.id.length)),
                                        position: $event.newIndex + parseInt(1),
                                      }
                                    }).then((payload) => {
                                        updateUObjectParent(payload)
                                      })
                                    "
                                  >
                                  <!-- @remove="tWorkPackageRemoveFromTWaggon({
                                    twaggon_id: waggon.id,
                                    drag_evt: $event,
                                  })"
                                  @add="tWorkPackageAddToWaggon({
                                    project_id: project_id,
                                    train_id: train.id,
                                    taktarea_id: taktarea.id,
                                    twaggon_id: waggon.id,
                                    old_twaggon_id: draggable_old_twaggon_id,
                                    drag_evt: {
                                      oldIndex: $event.oldIndex,
                                      newIndex: $event.newIndex
                                    },
                                    snack_bar: { bulk: false }
                                  })" -->
                                  <!-- @update="tWorkPackageChangePosition({
                                    project_id: project_id,
                                    train_id: train.id,
                                    taktarea_id: taktarea.id,
                                    twaggon_id: waggon.id,
                                    drag_evt: {
                                      oldIndex: $event.oldIndex,
                                      newIndex: $event.newIndex
                                    },
                                    snack_bar: { bulk: false }
                                    })" -->
                                  <v-hover
                                    v-for="workpackage in getUObjects({type: 'tworkpackages', ids: waggon.tworkpackages})"
                                    :key="`workpackagehoveractivator${workpackage.id}`"
                                    >
                                    <template #default="hover_workpackage_slot">
                                      <TWorkPackage
                                        :key="`workpackage${workpackage.id}`"
                                        :workpackage_count="waggon.tworkpackages.length"
                                        :workpackage="workpackage"
                                        :easter_egg="easter_egg"
                                        :color="getStatisticSettings.filter &&
                                                (
                                                (getStatisticSettings.colors.length !== 0 &&
                                                !getStatisticSettings.colors.includes(workpackage.color)) ||
                                                (getStatisticSettings.icons.length !== 0 &&
                                                !getStatisticSettings.icons.includes(workpackage.icon)) ||
                                                (getStatisticSettings.status.length !== 0 &&
                                                !getStatisticSettings.status.includes(workpackage.status)) ||
                                                (getStatisticSettings.trains.length !== 0 &&
                                                !getStatisticSettings.trains.includes(train.id))

                                              ) ||
                                              (isShowOwnWps &&
                                              getOwnTWorkPackages(project_id).length !== 0 &&
                                              !getOwnTWorkPackages(project_id).includes(workpackage.id))
                                              ?
                                              'grey darken-2':false"
                                        >
                                        <template #workpackage="workpackageslot">
                                          <StandardHover
                                            v-if="isTworkPackageHover(
                                              workpackage.id,
                                              workpackageslot.workpackage,
                                              hover_workpackage_slot.hover,
                                              new_milestone.milestone)"
                                            :class="$route.name === 'TaktPlanWorkPackageEdit'?'cursor-grab':'cursor-pointer'"
                                            :key="`workpackagehover${workpackage.id}`"
                                            @click.native="handleTWorkpackageClick(
                                              train,
                                              waggon,
                                              workpackageslot.workpackage,
                                              train.id,
                                              taktarea.id,
                                              waggon.id,
                                              workpackage.id,
                                              $event
                                              )"
                                            />
                                          <transition
                                            name="zoom"
                                            >
                                            <StandardBadge
                                              class="cursor-pointer"
                                              v-if="!(hover_waggon_slot.hover && isEditMode) &&
                                                    workpackageslot.workpackage.status &&
                                                    (workpackageslot.workpackage.status !== 'none' || workpackageslot.workpackage.stop_status !== 'none') &&
                                                    isShowStatusBadges &&
                                                    workpackage.status !== 'stop'
                                                    "
                                              :key="`workpackagebadge${workpackage.id}`"
                                              :icon="workpackage.stop_status !== 'none'?(workpackage.stop_status === 'ai_stop'?'ai_stop':'exclamation-triangle-negative'):getStatusArray.find(status => status.name === workpackageslot.workpackage.status).icon"
                                              color="white"
                                              :content_color="workpackageslot.workpackage.stop_status !== 'none' ? 'red':'black'"
                                              @click.native="$route.name === 'ProjectTaktPlan'?openWaggonInfo(waggon, train.id, taktarea.id, waggon.id, $event):''"
                                            />
                                          </transition>
                                          <StandardBadgeMini
                                            v-if="workpackageslot.workpackage.status &&
                                                  workpackageslot.workpackage.status !== 'none' &&
                                                  !isShowStatusBadges"
                                            />
                                        </template>
                                      </TWorkPackage>
                                    </template>
                                  </v-hover>
                                </draggable>
                                </template>
                              </TWaggon>
                            </transition>
                            </template>
                          </v-hover>
                        </draggable>
                        <template v-if="train.closed">
                          <div style="display: flex">
                            <TWaggon
                              v-for="waggon in (getTrainLength(train.id) - getTaktareaLength(taktarea.id) - train.train_start)"
                              :key="`waggonPlaceholder${taktarea.id}${waggon}`"
                              :dummy="true"
                            />
                          </div>
                        </template>
                        <template v-else-if="taktarea_index === train.taktareas.length-1">
                          <Placeholder :count="getTrainLength(train.id) - getTaktareaLength(taktarea.id) - train.train_start"/>
                        </template>
                        <TrainTail
                          v-if="taktarea_index === train.taktareas.length-1 ||
                            train.closed"
                          :is_taktarea="!train.closed"
                          />
                      </template>
                    </TaktArea>
                  </transition>
                </template>
              </v-hover>
            </draggable>
            </template>
          </Train>
        </draggable>
        </template>
      <!-- </div> -->
      <!-- spatial structure -->
      <div v-else style="position: relative; height: 100%">
        <!-- <div style="display: flex"> -->
        <TaktTimeHighLighter
          v-if="getCurrentTaktIndex(project_id) !== false"
          :index="Math.abs(getCurrentTaktIndex(project_id))"
          header_width="var(--project_taktplan_ta_header_width) * 1px + var(--project_taktplan_spatial_header_width) * 1px"
          z_index="2"
          />
        <TaktTimeHighLighter
          v-if="getCurrentTaktIndex(project_id) !== false &&
                getCurrentTaktIndex(project_id) >= 0"
          :index="getCurrentTaktIndex(project_id) + 1"
          header_width="var(--project_taktplan_ta_header_width) * 1px + var(--project_taktplan_spatial_header_width) * 1px"
          z_index="2"
          />
        <div style="width: 248px">
        <ProjectStructureTreeTaktplan
          v-for="site in getUObjects({type: 'sites', ids: project.sites})"
          :key="`site${site.id}`"
          :parent="site"
          :child_elements="getChildElements({parent_type: 'sites', parent_id: site.id})"
          :sticky_left="0"
          :project_length="getProjectLength(project_id)"
          :project_taktplan_spatial_header_width="project_taktplan_spatial_header_width"
          :project_id="project_id"
          :parent_color_index="0"
          @parentClicked="updateUDObject({
              url: [
                {[$event.type]: $event.id}
              ],
              update: {
                closed: !$event.closed
              }
            })"
        />
      </div>
      <!-- <ProjectStructureTaktplanTaktareas
        :container="getTaktareasForSpatialStructure({parent_type: 'projects', parent_id: project_id})"
      />
    </div> -->
  </div>
    </v-container>
  </v-card>
</template>
<script>
// import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';

import { ProjectMixin } from '@/mixins/Project.mixin.js'
import { TaktPlanMixin } from '@/mixins/TaktPlan.mixin.js'
import { TrainMixin } from '@/mixins/Train.mixin.js'
import { TWaggonMixin } from '@/mixins/TWaggon.mixin.js'
import { TaktAreaMixin } from '@/mixins/TaktArea.mixin.js'
import { TWorkPackageMixin } from '@/mixins/TWorkPackage.mixin.js'
import { FlexBarMixin } from '@/mixins/FlexBar.mixin.js'
import { SideBarMixin } from '@/mixins/SideBar.mixin.js'
import { InfoBoxMixin } from '@/mixins/InfoBox.mixin.js'
import { SwitchMixin } from '@/mixins/Switch.mixin.js'
import { MilestonesMixin } from '@/mixins/Milestones.mixin.js'

import draggable from "vuedraggable";

import TrainHead from '@/components/ProjectTaktPlan/TrainHead.component.vue'
import Placeholder from '@/components/ProjectTaktPlan/Placeholder.component.vue'
import Activator from '@/components/ProjectTaktPlan/Activator.component.vue'
import ActivatorDelete from '@/components/ProjectTaktPlan/ActivatorDelete.component.vue'
import ActivatorInsert from '@/components/ProjectTaktPlan/ActivatorInsert.component.vue'
import ActivatorSlider from '@/components/ProjectTaktPlan/ActivatorSlider.component.vue'
import StandardHover from '@/components/StandardComponents/StandardHover.component.vue'
import StandardBadge from '@/components/StandardComponents/StandardBadge.component.vue'
import StandardBadgeMini from '@/components/StandardComponents/StandardBadgeMini.component.vue'
import StandardFlexBox from '@/components/StandardComponents/StandardFlexBox.component.vue';
import StandardSwitch from '@/components/StandardComponents/StandardSwitch.component.vue';
import StandardStep from '@/components/StandardComponents/StandardStep.component.vue';



import TrainTail from '@/components/ProjectTaktPlan/TrainTail.component.vue'

import TaktTimeHighLighter from '@/components/ProjectTaktPlan/TaktTimeHighLighter.component.vue'
import HeaderRow from '@/components/ProjectTaktPlan/HeaderRow.component.vue'
import HeaderColumn from '@/components/ProjectTaktPlan/HeaderColumn.component.vue'
import HeaderColumnMonth from '@/components/ProjectTaktPlan/HeaderColumnMonth.component.vue'
import HeaderPlaceholder from '@/components/ProjectTaktPlan/HeaderPlaceholder.component.vue'
import HeaderTrainOpen from '@/components/ProjectTaktPlan/HeaderTrainOpen.component.vue'
import DateCircle from '@/components/ProjectTaktPlan/DateCircle.component.vue'
import HeaderRowStatistics from '@/components/ProjectTaktPlan/HeaderRowStatistics.component.vue'
import StatisticsBackgroundBlurr from '@/components/ProjectTaktPlan/StatisticsBackgroundBlurr.component.vue'
import StatisticsTakt from '@/components/ProjectTaktPlan/StatisticsTakt.component.vue'
import StatisticsBeamTaktSum from '@/components/ProjectTaktPlan/StatisticsBeamTaktSum.component.vue'
import StatisticsBeam from '@/components/ProjectTaktPlan/StatisticsBeam.component.vue'
import StatisticsCard from '@/components/ProjectTaktPlan/StatisticsCard.component.vue'
import StandardOverflowButton from '@/components/StandardComponents/StandardOverflowButton.component.vue'
import StandardDeleteButton from '@/components/StandardComponents/StandardDeleteButton.component.vue'
import StandardDialog from '@/components/StandardComponents/StandardDialog.component.vue'
import FlexBar from '@/components/ProjectTaktPlan/FlexBar.component.vue'
import SnackBar from '@/components/ProjectTaktPlan/SnackBar.component.vue'

import TFlex from '@/components/Taktify/TFlex.component.vue'


import MileStonesLane from '@/components/ProjectTaktPlan/MileStonesLane.component.vue'
import MileStone from '@/components/ProjectTaktPlan/MileStone.component.vue'

// @ is an alias to /src

export default {
  components: {
    draggable,
    TrainHead,
    Placeholder,
    Activator,
    ActivatorDelete,
    ActivatorInsert,
    ActivatorSlider,
    StandardHover,
    StandardBadge,
    StandardBadgeMini,
    TrainTail,
    TaktTimeHighLighter,
    HeaderRow,
    HeaderColumn,
    HeaderColumnMonth,
    HeaderPlaceholder,
    HeaderTrainOpen,
    DateCircle,
    HeaderRowStatistics,
    StatisticsBackgroundBlurr,
    StatisticsTakt,
    StatisticsBeamTaktSum,
    StatisticsBeam,
    StatisticsCard,
    StandardOverflowButton,
    StandardDeleteButton,
    FlexBar,
    SnackBar,
    StandardFlexBox,
    StandardSwitch,
    StandardStep,
    StandardDialog,
    TFlex,

    MileStonesLane,
    MileStone,
  },
  mixins: [
    ProjectMixin,
    TaktPlanMixin,
    TrainMixin,
    TWaggonMixin,
    TaktAreaMixin,
    TWorkPackageMixin,
    FlexBarMixin,
    SideBarMixin,
    InfoBoxMixin,
    SwitchMixin,
    MilestonesMixin,
  ],
  // beforeRouteUpdate (to, from, next) {
  //   this.leaveEditMode({project_id: this.project_id})
  //   next();
  // },
  beforeRouteLeave(to, from, next) {
    this.leaveEditMode({project_id: this.project_id})
    next();
  },
  props: ['project_id', 'project', 'milestone_selection', 'new_milestone', 'snackbar'],
  data: () => ({
    date: '',
    weekstart: '',
    test: false,
    show_calendar_edit: false,
    show_statistics: true,
    project_image: ''
  }),
  created(){
    if (this.$vuetify.breakpoint.smAndDown) {
      // hide flexbar here
    }
  },
  updated() {
  },
  computed: {
    // ...mapGetters('View', [
    //   'getStatisticsHeightVariables',
    // ]),
    ...mapGetters('Autopilot', [
      'getAutopilots',
    ]),
  },
  methods: {
    getSquareMeter(train, taktarea){
      if (train.closed) {
        // train
        let square_meters = 0;
        for (var i = 0; i < train.taktareas.length; i++) {
          square_meters += this.getTaktarea(train.taktareas[i]).square_meter;
        }
        return square_meters;
      } else {
        // taktarea
        return parseInt(taktarea.square_meter) !== 0 ? taktarea.square_meter:''
      }
    },
    addProjectImage(){
      let image_data = new FormData();
      image_data.append('image', this.$refs.project_image.files[0]);
      this.uploadProjectImage({
        project_id: this.$route.params.project_id,
        image: image_data
      })
    },
    ...mapActions('Project', [
      'uploadProjectImage'
    ]),
    // ...mapActions('View', [
    //   'setStatisticsHeightVariables'
    // ]),
    ...mapActions('Autopilot', [
      'clearAutopilots'
    ]),




  }
}
</script>
<style>
  .taktplan {
    position: absolute;
    width: calc(100% - 8px);
    transition: width 0s 200ms;
    will-change: width;
  }
  .grow-x-enter, .grow-x-leave-to {
    width: 0px;
  }
  .grow-x-enter-active, .grow-x-leave-active {
    overflow: hidden;
    transition: all 0.1s ease-in-out;
  }
  .grow-y-enter, .grow-y-leave-to {
    height: 0px;
  }
  .grow-y-enter-active, .grow-y-leave-active {
    overflow: hidden;
    transition: all 0.1s ease-in-out;
  }
  .slide-enter, .slide-leave-to {
    transform: translateX(300px);
  }
  .slide-enter-active, .slide-leave-active {
    transition: all 0.2s ease-in-out;
  }
  .zoom-translate-enter, .zoom-translate-leave-to {
    transform: translate(var(--waggon_offset_x), var(--waggon_offset_y)) scale(0, 0);
  }
  .zoom-translate-enter-active, .zoom-translate-leave-active {
    transition: all 0.2s ease-in-out;
  }
  .zoom-enter, .zoom-leave-to {
    transform: translate(2px, -3px) scale(0.3, 0.3);
  }
  .zoom-enter-active, .zoom-leave-active {
    transition: all 0.2s ease-in-out;
  }
  .snack-bar-slide-y-enter, .snack-bar-slide-y-leave-to {
    transform: translateY(100px)
  }
  .snack-bar-slide-y-enter-active, .snack-bar-slide-y-leave-active {
    transition: all 0.2s ease-in-out;
  }
</style>
